/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Duplicate_PlayerInputs */



/**
* | output |
* | --- |
* | "Duplicate player in seating" |
*
* @param {Err_Tournament_Duplicate_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_duplicate_player = /** @type {((inputs?: Err_Tournament_Duplicate_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Duplicate_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueur en double dans le placement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugador duplicado en los asientos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogador duplicado nos assentos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatore duplicato nella disposizione")
	return /** @type {LocalizedString} */ ("Duplicate player in seating")
});